import React, { useRef } from 'react'
import { Portal } from "@commonComponents/portal"
import CustomPopup from '@commonComponents/customPopup'
import { Button } from 'semantic-ui-react'
import InventoryList from './components/InventoryList'

const CCSAirUK = () => {
    return (
        <Portal targetElementId='container-ccs-air-uk'>
            <CCSAirUKContainer />
        </Portal>
    )
}

export default CCSAirUK


function CCSAirUKContainer() {
    const popup = useRef()
    return (
        <div className='ccs-air-container'>
            <Button basic color='primary' onClick={() => {
                popup.current?.openPopup()
            }}>CCS AIR UK</Button>
            <CustomPopup
                onClose={() => popup.current?.closePopup()}
                content={true}
                description={<InventoryList />}
                ref={popup}
                className="ccs-air-container__popup"
                header={<div>CCS AIR</div>}
            />
        </div>
    )
}